// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"23":"7aeb12f0","81":"519e78d3","815":"f8e7e2f1","902":"20c39cde"}[chunkId] + ".chunk.js";
};